module.exports = __webpack_public_path__ + "img/funmi.32e720f8.png";